export default {
  steps: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  step:[],
  selected_steps : {},
  steps_status:[]
}
